// Ж8 (TZ-6 п.8): мягкое предупреждение по названию организации — зеркало b2b_tasks.org_name_warning
const MARKERS = ["самозанятый", "самозанятая", "ип", "ооо", "оао", "зао", "пао", "ао", "нко"];
export const ORG_NAME_WARNING = "Проверьте название: оно попадёт в документы.";

export const orgNameWarning = (name) => {
  const clean = String(name || "").replace(/[\s«»"'.,]+/g, " ").trim().toLowerCase();
  if (!clean) return null;
  return clean.length < 3 || MARKERS.includes(clean) ? ORG_NAME_WARNING : null;
};
